const store = new Vuex.Store({
    modules: {
        Layout: Layout.store,
        Text: Text.store
    }
});